/**
 * PDP Section Stacking Engine
 * Overlap-based: each card fades/scales as the NEXT card scrolls over it.
 * Also drives scroll-marquee horizontal shift.
 */
(function () {
  'use strict';

  /* ── 1. Discover sections ──────────────────────────────────────────── */

  var main = document.querySelector('.section-main-product');
  if (!main) return;
  var wrap = main.closest('.shopify-section');
  if (!wrap) return;

  var sections = [];
  var el = wrap.nextElementSibling;
  var z = 1;

  function shouldStackSection(sectionEl) {
    if (!sectionEl || !sectionEl.classList.contains('shopify-section')) return false;

    if (sectionEl.querySelector('#reviews-section')) return false;
    if (sectionEl.querySelector('.shopify-app-block')) return false;

    return true;
  }

  while (el) {
    if (!shouldStackSection(el)) break;
    el.classList.add('pdp-stack-section');
    el.style.setProperty('--stack-z', z);
    sections.push(el);
    z += 1;
    el = el.nextElementSibling;
  }

  /* Ensure sections after the stack paint above any pinned sticky cards */
  while (el) {
    if (el.classList.contains('shopify-section')) {
      el.style.position = 'relative';
      el.style.zIndex = z;
      el.style.backgroundColor = 'var(--color-background, #fff)';
      z += 1;
    }
    el = el.nextElementSibling;
  }

  if (sections.length < 2) return;

  /* ── Respect reduced-motion preference ───────────────────────────────── */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── 2. Discover marquee containers ────────────────────────────────── */

  var marquees = document.querySelectorAll('[data-scroll-marquee]');

  /* ── 3. Animation values ───────────────────────────────────────────── */

  var SCALE_END    = 0.92;
  var MARQUEE_RANGE = 15;

  /* ── 4. rAF scroll loop ────────────────────────────────────────────── */

  var ticking = false;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  function update() {
    var wh = window.innerHeight;

    /* — Section stacking (overlap-based) — */
    for (var i = 0; i < sections.length; i++) {
      var rect = sections[i].getBoundingClientRect();
      var nextCard = sections[i + 1];

      // Last card never fades
      if (!nextCard) {
        sections[i].style.setProperty('--stack-progress', 0);
        sections[i].style.setProperty('--stack-scale', 1);
        continue;
      }

      // Only animate when card is stuck at top
      if (rect.top <= 1) {
        var nextRect = nextCard.getBoundingClientRect();
        var cardH = sections[i].offsetHeight;

        // How much has the next card overlapped this one?
        // 0 = next card just touching bottom, 1 = fully covered
        var overlap = 1 - (nextRect.top / cardH);
        overlap = Math.max(0, Math.min(1, overlap));

        var scale = 1 - (overlap * (1 - SCALE_END));

        sections[i].style.setProperty('--stack-progress', overlap);
        sections[i].style.setProperty('--stack-scale', scale);
        sections[i].style.pointerEvents = overlap > 0.95 ? 'none' : '';
      } else {
        sections[i].style.setProperty('--stack-progress', 0);
        sections[i].style.setProperty('--stack-scale', 1);
        sections[i].style.pointerEvents = '';
      }
    }

    /* — Scroll marquee — */
    for (var m = 0; m < marquees.length; m++) {
      var mRect = marquees[m].getBoundingClientRect();

      if (mRect.top < wh && mRect.bottom > 0) {
        var mProgress = 1 - (mRect.bottom / (wh + mRect.height));
        var moveLeft  = mProgress * -MARQUEE_RANGE;
        var moveRight = -MARQUEE_RANGE + (mProgress * MARQUEE_RANGE);

        marquees[m].style.setProperty('--marquee-left', moveLeft + '%');
        marquees[m].style.setProperty('--marquee-right', moveRight + '%');
      }
    }

    ticking = false;
  }

  /* ── 5. Bind ───────────────────────────────────────────────────────── */

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
